import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import { createId, Json } from "./base";
import InputList from "./Input";
import Template, { MapParameters } from "./Template";

export default function WorkflowServiceApiKey({ json, onChange, rootJson }: {
    json: Json;
    onChange: (current: ((json: Json) => Json)) => void;
    rootJson: Json
}): ReactElement {
    const connection = json.connection as Json;
    const changeConnection = (child: Json) => {
        onChange(current => ({
            ...current,
            connection: {
                ...connection,
                ...child,
            },
        }));
    };
    const deleteKey = (key: string) => {
        onChange(current => {
            const copy = { ...current };
            delete (copy.connection as Record<string, string>)[key];
            return copy;
        });
    };

    if (connection?.apiKey) {
        const apiKey = connection?.apiKey as Json | undefined;
        const changeApiKey = (child: Json) => {
            changeConnection({
                apiKey: {
                    ...apiKey,
                    ...child,
                },
            });
        };
        return (
            <div>
                <div
                    className="d-flex justify-content-between align-items-start"
                >
                    <h5>Api Key Config</h5>
                    <button
                        type="button"
                        className="btn btn-none btn-sm p-0 text-light  "
                        onClick={() => deleteKey("apiKey")}
                    >
                        <BiTrash />
                    </button>

                </div>

                <ExpandingSection title="Input Key Field">

                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">API key field name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onChange={evt => changeApiKey({ apiKeyFieldName: evt.target.value })}
                            value={apiKey?.apiKeyFieldName as string ?? ""}
                        />
                        <Form.Text>
                            API key field name
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Placeholder</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onChange={evt => changeApiKey({ placeholder: evt.target.value })}
                            value={apiKey?.placeholder as string ?? ""}
                        />
                        <Form.Text>
                            Input Placeholder
                        </Form.Text>
                    </Form.Group>

                </ExpandingSection>

                <ExpandingSection title="User Facing">
                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Instructions</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Please click Authorize to continue"
                            required
                            as="textarea"
                            onChange={evt => changeApiKey({ instructions: evt.target.value })}
                            value={apiKey?.instructions as string ?? ""}
                        />
                        <Form.Text>
                            Instructions shown to the end users
                        </Form.Text>
                    </Form.Group>

                    <h5>Input</h5>

                    <InputList
                        json={apiKey?.input as Json[] ?? []}
                        rootJson={rootJson}
                        onChange={value => changeApiKey({
                            input: value,
                        })}
                    />

                </ExpandingSection>

                <ExpandingSection title="Connection">

                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Url</Form.Label>
                        <Template
                            json={(apiKey?.connection as Json)?.url as Json}
                            onChange={value => changeApiKey({
                                connection: {
                                    ...(apiKey?.connection as Json),
                                    url: value,
                                },
                            })}

                        />
                        <Form.Text className="d-block">
                            This helps set up a default url that applies to all downstream requests.
                        </Form.Text>
                    </Form.Group>

                    <MapParameters
                        title="Headers"
                        json={(apiKey?.connection as Json)?.headers as Json}
                        onChange={value => {
                            changeApiKey({
                                connection: {
                                    ...(apiKey?.connection as Json),
                                    headers: value,
                                },
                            });
                        }}
                    />
                </ExpandingSection>

            </div>
        );
    }

    return (
        <button
            type="button"
            className="btn btn-primary py-1 px-2"
            onClick={() => changeConnection({
                id: `urn:fq:workflow-service-connection:(urn:fq:workflow-service:${json.id},${createId()})`,
                ...connection,
                apiKey: {
                },
            })}
        >
            API Key
        </button>
    );
}
